import { OwnableProduct_ProductType as ProductType } from '__generated__/graphql-types';
import { compose, withProps } from 'recompose';

import type { EnrollmentChoices } from 'bundles/enroll-common/components/xdp/withEnrollment';
import {
  type OwnableProductByLegacyProductId,
  withFindOwnableProductsByLegacyProductIds,
} from 'bundles/ownable-products-common/hooks/useFindOwnableProducts';

export type PropsToWithPrice = {
  enrollmentAvailableChoices?: EnrollmentChoices;
  s12nId?: string;
};

type PropsFromWithPriceOwnableProducts = {
  ownableProducts?: Array<OwnableProductByLegacyProductId>;
};

export type PropsFromWithPrice = PropsFromWithPriceOwnableProducts;

type LegacyProductId = { productType: ProductType; productItemId: string };

const withPrice = <InputProps extends PropsToWithPrice>() =>
  compose<PropsFromWithPrice, InputProps>(
    withProps<InputProps, InputProps>(({ enrollmentAvailableChoices, s12nId }) => {
      if (!enrollmentAvailableChoices) {
        return { ...({ enrollmentAvailableChoices, s12nId } as InputProps), legacyProductIds: [], skip: true };
      }

      let legacyProductIds: Array<LegacyProductId> = [];

      // if user can subscribe to multiple s12ns but can't do free trial for any s12n,
      // retrieve the price for every s12n
      if (
        enrollmentAvailableChoices.isMixAndMatch &&
        !enrollmentAvailableChoices.canEnrollThroughS12nSubscriptionFreeTrial
      ) {
        legacyProductIds = enrollmentAvailableChoices.mixAndMatchAvailableS12nSubscriptions.map((product) => ({
          productType: ProductType.ProductTypeSpecializationSubscription,
          productItemId: product.productId.productItemId,
        }));
      } else if (enrollmentAvailableChoices.canSubscribeToS12n && s12nId) {
        legacyProductIds = [
          {
            productType: ProductType.ProductTypeSpecializationSubscription,
            productItemId: enrollmentAvailableChoices.availableS12nSubscriptions?.[0]?.productItemId as string,
          },
        ];
      }

      return {
        ...({ enrollmentAvailableChoices, s12nId } as InputProps),
        legacyProductIds,
        skip: legacyProductIds.length === 0,
      };
    }),
    withFindOwnableProductsByLegacyProductIds
  );

export { withPrice };
